import { IPaging } from '@src/models/api';
import { TColumnWidthData, TSkeletonConfig } from './models';

export const DEFAULT_TABLE_SKELETON: TSkeletonConfig = {
  headerHeight: '32px',
  rowHeight: '72px',
  rowsNumber: 5,
};

export const DEFAULT_LIMIT_ROWS = 20;

export const DEFAULT_INIT_TABLE_STATE_PAGING: IPaging = {
  offset: 0,
  limit: DEFAULT_LIMIT_ROWS,
};

export const PAGING_LIMIT_DEFAULT_OPTIONS = [
  { value: 20, label: '20' },
  { value: 100, label: '100' },
  { value: 500, label: '500' },
];

/**
 * Дефолтный конфиг определяющий ширину колонок
 * По дефолту в стилях используется minmax() для поддержания адаптивности у колонок
 * @link https://developer.mozilla.org/ru/docs/Web/CSS/minmax
 */
export const COLUMN_WIDTH_CONFIG: TColumnWidthData = {
  BOOLEAN: {
    min: '100px',
    max: '1.33fr',
  },
  BOOLEAN_TWO_VARIANTS: {
    min: '100px',
    max: '1.33fr',
  },
  DATE: {
    min: '120px',
    max: '1.33fr',
  },
  DATE_TIME: {
    min: '200px',
    max: '1.33fr',
  },
  DAY_OF_WEEK: {
    min: '120px',
    max: '1.33fr',
  },
  DURATION: {
    min: '150px',
    max: '1.33fr',
  },
  EMAIL: {
    min: '250px',
    max: '2.00fr',
  },
  HTML: {
    min: '250px',
    max: '2.33fr',
  },
  JSX: {
    min: '150px',
    max: '2.33fr',
  },
  LONG_TEXT: {
    min: '250px',
    max: '2.33fr',
  },
  MEDIA: {
    min: '150px',
    max: '1.33fr',
  },
  MONTH: {
    min: '120px',
    max: '1.33fr',
  },
  MONTH_DAY: {
    min: '120px',
    max: '1.33fr',
  },
  NUMBER: {
    min: '100px',
    max: '1.00fr',
  },
  NUMBER_FRACTION_DIGITS_1: {
    min: '150px',
    max: '1.33fr',
  },
  NUMBER_FRACTION_DIGITS_2: {
    min: '150px',
    max: '1.33fr',
  },
  NUMBER_INT: {
    min: '150px',
    max: '1.33fr',
  },
  QUARTER: {
    min: '150px',
    max: '1.33fr',
  },
  RECORD: {
    min: '150px',
    max: '1.33fr',
  },
  TEXT: {
    min: '200px',
    max: '2.33fr',
  },
  URL: {
    min: '200px',
    max: '1.33fr',
  },
  WEEK: {
    min: '150px',
    max: '1.33fr',
  },
  YEAR: {
    min: '100px',
    max: '1.33fr',
  },
  YEAR_MONTH: {
    min: '120px',
    max: '1.33fr',
  },
  YEAR_MONTH_DAY: {
    min: '150px',
    max: '1.33fr',
  },
  YEAR_MONTH_DAY_HOUR: {
    min: '150px',
    max: '1.33fr',
  },
  YEAR_QUARTER: {
    min: '150px',
    max: '1.33fr',
  },
  YEAR_WEEK: {
    min: '150px',
    max: '1.33fr',
  },
  PREDICATE: {
    min: '150px',
    max: '1.33fr',
  },
};

export const DATA_ELEM_BASE = 'table';
const getDataName = (name: string[]) => [DATA_ELEM_BASE, ...name].join('-');
export const DATA_ELEM_WRAPPER = getDataName(['wrapper']);
export const DATA_ELEM_PAGING = getDataName(['paging']);

export const DATA_ELEM_HEAD = getDataName(['head']);
export const DATA_ELEM_HEAD_CELL = getDataName([DATA_ELEM_HEAD, 'cell']);

export const DATA_ELEM_CELL = getDataName(['cell']);
export const DATA_ELEM_ROW = getDataName(['row']);
